<script lang="ts">
  import { faFolderTree } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
</script>

<div class="flex items-center justify-center w-full h-full">
  <div class="text-center">
    <FontAwesomeIcon icon={faFolderTree} class="w-8 h-8 help-icon" />
    <p class="help-text">
      You can browse documents across all projects here,
      <br />enabling you to explore all available evidence and
      <br />find specific insights to support your needs.
      <br /><br />
      -----------
      <br />
      <span class="help-text italic">Click a document link to see it in the viewer here.</span>
    </p>
  </div>
</div>